export default __webpack_public_path__ + "b1d87799a34159aa8af3cef0ea4fba29.svg";